module.exports = __webpack_public_path__ + "static/media/AmploFooter.0b8a6101.svg";